import { Platform } from '@angular/cdk/platform';
import { Component } from '@angular/core';

import { GeneralService } from 'src/app/shared/services/general.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as GlobalVariables from '../../global';
import * as moment from 'moment';
import { NavigationExtras, Router } from '@angular/router';
import { APIServerResponse, NewsCO } from 'src/app/shared/models/ApiModels';


@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent {

  // newsrange = [{key:5,value:'Latest'},{key:15,value:'15 Days ago'},{key:30,value:'30 Days ago'},];
  // newsList:Array<NewsCO>;
  // selNewsRange:any;
  // latestNews:NewsCO;
  // defaultImg ="../../../assets/our aim.png";
  // imageBaseUrl = GlobalVariables.fileDownload + "?fileUuid=";
  // count=0;
  // newsList2D=[];
  
  // column=0;

  // constructor(private genS: GeneralService,private sanitizer: DomSanitizer,private router: Router, private platform: Platform){}

  // ngOnInit(): void {
  //   this.selNewsRange=this.newsrange[2];
  //   this.getNewsList();
  // }

  // getNewsList()
  // {
  //   let obj={days:this.selNewsRange?.key};
  //   this.genS.getNewsList(obj).subscribe((res: APIServerResponse) => {
  //     if(res.data)
  //     {
  //       this.newsList = res.data;
  //       if(this.newsList != null )
  //       {           
  //         // this.latestNews = this.newsList.pop();
  //         this.latestNews = this.newsList[0];
  //         this.newsList.splice(0,1);
  //         this.count = Math.floor(this.newsList.length/2);
  //         if(this.newsList.length%2 != 0)
  //         {
  //           this.count=this.count+1;
  //         }
  //         // console.log(this.count);
  //         let tempList=[]; 
  //         let i=1;
  //         this.newsList.forEach(element => {
  //             tempList.push(element);
  //             if(i%2== 0)
  //             {
  //               this.newsList2D.push(tempList);
  //               tempList=[];
  //             }
             
  //             i++;
  //         });
  //         if(tempList.length > 0)
  //         {
  //           this.newsList2D.push(tempList);
  //         }
  //       }
        
  //     }
  //   });
  // }

  // transformDate(strDate:any)
  // {
  //   let changedDate="";
  //   if (strDate!=null)
  //   {
  //     changedDate=  moment(strDate,'YYYY-MM-DD').format('DD MMM YYYY');
   
  //   }
  //   return changedDate;
  // }

  // goToFullNews(news: any)
  // {
  //   sessionStorage.removeItem("selectedNews")
  //   sessionStorage.setItem("selectedNews", JSON.stringify(news));
  //   this.router.navigate(['newspage1'], {queryParams:{newsId: news.id}});
  // }
  

  // share() {
  //   if (this.platform.isBrowser) {
  //     navigator.share({
  //       title: document.title,
  //       text: 'Check out this page!',
  //       url: window.location.href
  //     })
  //     .then(() => console.log('Successful share'))
  //     .catch((error) => console.log('Error sharing', error));
  //   }
  // }
  

}
